<template>
  <label
    class="lp-switch-wrapper"
    :class="[preview && 'lp-switch-wrapper-preview']"
  >
    <span
      class="lp-switch"
      :class="[
        `lp-switch-${type}`,
        modelValue && `lp-switch-${type}-checked`,
        disabled && `lp-switch-${type}-disabled`,
        !preview && pulse && !disabled && 'pulse',
      ]"
    >
      <span v-if="preview">
        {{ modelValue ? onText : offText }}
      </span>
      <input
        v-else
        type="checkbox"
        class="lp-switch-input"
        :disabled="disabled"
        v-bind="$attrs"
        @change="toggle"
      />
      <span v-if="!preview" class="lp-switch-circle ly-row ly-center-center">
        <lp-icon
          v-if="activeIcon || inactiveIcon"
          :name="modelValue ? activeIcon : inactiveIcon"
          size="sm"
        />
      </span>
    </span>
    <span
      v-if="label || subLabel || $slots.defaul || $slots.sublabel"
      class="lp-switch-label-group"
    >
      <span
        v-if="label && !$slots.default"
        class="lp-switch-label"
        :class="[disabled && 'lp-switch-label-disabled']"
      >
        {{ label }}
        <span v-if="!preview && required" class="text-blue">*</span>
      </span>
      <span
        v-if="subLabel && !$slots.sublabel"
        class="lp-switch-label it-switch-label-sub"
        :class="[disabled && 'lp-switch-label-disabled']"
      >
        {{ subLabel }}
      </span>

      <span
        v-if="$slots.default"
        class="lp-switch-label"
        :class="[disabled && 'lp-switch-label-disabled']"
      >
        <slot />
      </span>
      <span
        v-if="$slots.sublabel"
        class="lp-switch-label it-switch-label-sub"
        :class="[disabled && 'lp-switch-label-disabled']"
      >
        <slot name="sublabel" />
      </span>
    </span>
  </label>
</template>

<script setup lang="ts">
import { Colors } from '@/models/enums'
import { t } from '@/plugins/i18n'

defineOptions({
  name: 'lp-switch',
  inheritAttrs: false,
})

type SwitchProps = {
  type?: Colors
  label?: string
  subLabel?: string
  pulse?: boolean
  disabled?: boolean
  modelValue: boolean
  required?: boolean
  preview?: boolean
  onText?: string
  offText?: string
  activeIcon?: string
  inactiveIcon?: string
}
const props = withDefaults(defineProps<SwitchProps>(), {
  type: Colors.BLACK,
  label: '',
  subLabel: '',
  pulse: false,
  disabled: false,
  modelValue: false,
  required: false,
  preview: false,
  onText: t('Shared.Yes'),
  offText: t('Shared.No'),
  activeIcon: '',
  inactiveIcon: '',
})

const emit = defineEmits(['update:modelValue'])

function toggle() {
  if (props.disabled) {
    return
  }
  const newValue = !props.modelValue
  emit('update:modelValue', newValue)
}
</script>
